import React from 'react'

import type { IconProps } from './types'

const SimilacVideo: React.FC<IconProps> = ({ size = 40, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="m7.869 17.79 31.64-7.621a.52.52 0 0 0 .383-.628l-1.188-5.034a.516.516 0 0 0-.622-.386l-31.64 7.62a.52.52 0 0 0-.383.629l1.188 5.034c.067.28.345.452.622.386"
        fill="#E4E8EC"
      />
      <path
        d="M8.733 44h31.462a1.05 1.05 0 0 0 1.044-1.055V19.593a1.05 1.05 0 0 0-1.044-1.055H8.733a1.05 1.05 0 0 0-1.044 1.055v23.352A1.05 1.05 0 0 0 8.733 44"
        fill="#F1BD00"
      />
      <path
        d="M41.239 23.8H7.689v-5.142c0-.285.112-.558.311-.76.2-.201.47-.314.753-.314h31.422c.282 0 .553.113.752.315.2.201.312.474.312.76z"
        fill="#E4E8EC"
      />
      <path
        d="M41.24 24.627H7.69a.82.82 0 0 1-.58-.242.833.833 0 0 1 0-1.173.82.82 0 0 1 .58-.242h33.55c.218 0 .426.087.58.242a.833.833 0 0 1 0 1.172.82.82 0 0 1-.58.243"
        fill="#1B3250"
      />
      <path
        d="M11.343 24.627a.82.82 0 0 1-.735-.46.84.84 0 0 1 .083-.87l4.69-6.216a.82.82 0 0 1 .542-.32.81.81 0 0 1 .82.405.84.84 0 0 1-.057.92l-4.69 6.215a.82.82 0 0 1-.653.326m7.367 0a.82.82 0 0 1-.735-.461.84.84 0 0 1 .083-.87l4.69-6.215a.82.82 0 0 1 .862-.3.82.82 0 0 1 .5.385.84.84 0 0 1-.057.92l-4.69 6.215a.82.82 0 0 1-.653.326m7.52.001a.81.81 0 0 1-.736-.462.84.84 0 0 1 .083-.87l4.69-6.215a.82.82 0 0 1 1.151-.158.83.83 0 0 1 .157 1.163l-4.69 6.216a.82.82 0 0 1-.656.326m6.789-.001a.82.82 0 0 1-.735-.461.84.84 0 0 1 .083-.87l4.69-6.215a.82.82 0 0 1 1.15-.157.83.83 0 0 1 .155 1.162L33.67 24.3a.82.82 0 0 1-.654.326"
        fill="#1B3250"
      />
      <path
        d="m28.488 31.369-4.481-2.613a1.88 1.88 0 0 0-1.895 0c-.288.168-.527.41-.693.7a1.93 1.93 0 0 0-.253.957v5.225c0 .336.087.667.253.958s.406.533.694.701a1.88 1.88 0 0 0 1.897-.002l4.48-2.612a1.928 1.928 0 0 0-.003-3.314"
        fill="#E4E8EC"
      />
      <path
        d="M30.21 13.233a.8.8 0 0 1-.52-.187l-5.987-4.95a.83.83 0 0 1-.297-.559.84.84 0 0 1 .428-.813.815.815 0 0 1 .908.089l5.987 4.95a.83.83 0 0 1 .253.92.83.83 0 0 1-.772.55m-7.314 1.759a.82.82 0 0 1-.52-.187l-5.987-4.95a.831.831 0 0 1 .438-1.466.82.82 0 0 1 .601.184l5.988 4.949a.83.83 0 0 1 .253.92.83.83 0 0 1-.773.55m-7.168 1.723a.8.8 0 0 1-.52-.187l-5.986-4.95a.831.831 0 0 1 .438-1.466.82.82 0 0 1 .601.184l5.987 4.949a.83.83 0 0 1 .253.92.82.82 0 0 1-.773.55m21.087-5.07a.8.8 0 0 1-.52-.187l-5.987-4.95a.832.832 0 0 1 .438-1.467.82.82 0 0 1 .601.183l5.987 4.95a.83.83 0 0 1 .253.92.83.83 0 0 1-.773.55"
        fill="#284A75"
      />
    </svg>
  )
}

export default SimilacVideo
